import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UtilHelper } from 'src/shared/helpers/util-helper';
import { ExtendedKeyValuePair } from '@app-shared/models/key-value-pair.model';
import { IProduct } from '@empf-shared/services/product/models/IProduct';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomToastService } from '../../services';
import { IDeliveryCommitment } from '@empf-shared/services/transaction/delivery-commitment/IDeliveryCommitment';
import { BestEffortsDeliveryData } from '@origination-shared/services/delivery-commitment/models/inner/BestEffortsDeliveryData';

@Component({
    selector: 'app-best-efforts-review-form',
    templateUrl: './best-efforts-review-form.component.html',
    styleUrls: ['./best-efforts-review-form.component.sass']
})
export class BestEffortsReviewFormComponent implements OnInit {
    @Input() bestEffortsDeliveryData: any;
    @Input() cmsModel: any;
    @Input() dcExistingModel: any;
    @Input() dcMainModel: any;
    @Input() propertyTypeOptions: ExtendedKeyValuePair[] = [];
    @Input() loanPurposesOptions: ExtendedKeyValuePair[] = [];
    @Input() occupancyOptions: ExtendedKeyValuePair[] = [];
    @Input() productsList: IProduct[];
    @Input() repriceChanged: boolean = false;

    @Output() submitTradBEReviewDC: EventEmitter<{ dc: IDeliveryCommitment, be: BestEffortsDeliveryData }> = new EventEmitter<{ dc: IDeliveryCommitment, be: BestEffortsDeliveryData }>();
    @Output() changeTradBEDC: EventEmitter<void> = new EventEmitter<void>();
    @Output() cancelTradBEDC: EventEmitter<void> = new EventEmitter<void>();

    loanPurposeSelected: string;
    propertyTypeSelected: string;
    occupancySelected: string;
    productSelected: string;
    commitmentExpirationDateCount: number = 0;
    noteRatePercent: number;
    coBorrowers: any[] = [];
    formSubmitted: boolean;
    validationErrors: Array<string>;
    bestEffortsValidated: boolean = false
    @Output() submitBEDCModifyClickEmit: EventEmitter<{ dc: IDeliveryCommitment, be: BestEffortsDeliveryData }> = new EventEmitter<{ dc: IDeliveryCommitment, be: BestEffortsDeliveryData }>();

    constructor(private modalService: NgbModal, private router: Router, private route: ActivatedRoute, private toastr: CustomToastService) { }

    ngOnInit() {
        console.log('BestEffortsReviewFormComponent initialized');
        const deliveryDate = new Date(this.dcExistingModel.deliveryCommitment.originalDeliveryDate);
        const entryDate = new Date(this.dcExistingModel.deliveryCommitment.entryDate);
        this.commitmentExpirationDateCount = Math.ceil(
            (deliveryDate.getTime() - entryDate.getTime()) / (1000 * 60 * 60 * 24)
        );

        const data: any = this.bestEffortsDeliveryData?.bestEffortsDeliveryData?.[0] ?? {};
        this.coBorrowers = [1, 2, 3].map(i => ({
            firstName: data[`coBorrower${i}FirstName`] ?? null,
            middleInitial: data[`coBorrower${i}MiddleInitial`] ?? null,
            lastName: data[`coBorrower${i}LastName`] ?? null,
            ssn: data[`coBorrower${i}SSN`] ?? null,
            suffix: data[`coBorrower${i}Suffix`] ?? null
        })).filter(cb => cb.firstName || cb.lastName || cb.ssn);

        this.noteRatePercent = Number((this.dcExistingModel.deliveryCommitment.noteRate * 100).toFixed(3));

        this.getPropertyTypeandLoanPurposeForDisplay();
    }

    getPropertyTypeandLoanPurposeForDisplay() {
        this.loanPurposeSelected = this.loanPurposesOptions?.find(item => item.value === this.bestEffortsDeliveryData.bestEffortsDeliveryData[0].loanPurpose)?.name ?? null;
        this.propertyTypeSelected = this.propertyTypeOptions?.find(item => item.value === this.bestEffortsDeliveryData.bestEffortsDeliveryData[0].propertyType)?.name ?? null;
        this.occupancySelected = this.occupancyOptions?.find(item => item.name === this.bestEffortsDeliveryData.bestEffortsDeliveryData[0].occupancy)?.name ?? null;

        const matchedProduct = this.productsList?.find(
            product => product.productCode === this.dcExistingModel.deliveryCommitment.productCode
        );
        this.productSelected = matchedProduct ? matchedProduct.productName : null;
  }
  
    onSubmitReview() {

        if (this.repriceChanged) {
            this.submitBEDCModifyClick();
        } else {
            this.submitEditDc();
        }
    }
  submitEditDc() {

    this.toastr.remove();

    this.formSubmitted = true;
    this.validationErrors = [];
    this.bestEffortsValidated = true;
    const existingdc= this.dcExistingModel.deliveryCommitment;
    const bestEffortsDeliveryData = this.bestEffortsDeliveryData.bestEffortsDeliveryData[0];
    this.submitTradBEReviewDC.emit({ dc: existingdc, be: bestEffortsDeliveryData }); // Emit the event
  }

  changeDC()
  {
    this.changeTradBEDC.emit();
  }

   cancelDC()
   {
    this.cancelTradBEDC.emit();
   }
    submitBEDCModifyClick() {
        const existingdc = this.dcExistingModel.deliveryCommitment;
        const bestEffortsDeliveryData = this.bestEffortsDeliveryData.bestEffortsDeliveryData[0];

        this.submitBEDCModifyClickEmit.emit({ dc: existingdc, be: bestEffortsDeliveryData });
    }
}
